import React, { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import PageTitle from "../../../jsx/layouts/PageTitle";
import { useNavigate } from "react-router-dom";
import ImportExcelModal from "./ImportExcelModal";
import { getAdminCategoryType } from "../../../services/adminApiService/adminCategoryType/AdminCategoryTypeApi";
import { getDwnLoadOrganisationList, getOrganisationList } from "../../../services/adminApiService/organisationApi/OrganisationApiService";
import { useParams } from "react-router-dom";
import { formatStatus, getStatusColor } from "../../../utils/colorAsperStatus";
import ReactPaginate from "react-paginate";
import { formatDateTime } from "../../../utils/dateTimeFormate";
import FilterNumber from "../../../jsx/components/FilterNumberDropDown/FilterNumber";
import SearchFilter from "../../../jsx/components/SearchFilter/SearchFilter";
import useSearchValue from "../../../hooks/useSearchValue";
import DistrictFilter from "../districtFilter/DistrictFilter";
import { LocationContext } from "../../../context/LocationContext";
import CategorySubCategoryFilter from "../categorySubCateogoryFilter/CategorySubCategoryFilter";
import { useCategoryFilter } from "../../../context/CategoryFilterContext";
import RefreshButton from "../../../jsx/components/RefreshButton/RefreshButton";
import { useFilterReset } from "../../../hooks/useFilterReset";
import SportFilter from "../sportFilter/SportFilter";
import { useSport } from "../../../context/SportContext";
import DownloadExcelButton from "../../../jsx/components/DownloadExcelButton.jsx/DownloadExcelButton";
import { organisationExcelHeaders } from "./InsitutionExcelHeader";
import { AuthContext } from "../../../context/AuthContext";
import TextMasked from "../../../utils/TextMasked";


const OrganizationList = () => {
  const { user } = useContext(AuthContext);
  const { selectedDistrictId, setSelectedDistrictId } = useContext(LocationContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [showImportModal, setShowImportModal] = useState(false);
  const [adminCategoryTypeData, setAdminCategoryTypeData] = useState([]);
  const [organisationdataList, setOrganisationdataList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
  const { selectedSubCategoryId, setSelectedSubCategoryId } = useCategoryFilter();
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const { selectedSportId, setSelectedSportId } = useSport();
  const [downloadNumberPage, setDownloadNumberPerPage] = useState('');
  const navigate = useNavigate();
  const handleVerificationClick = (id) => {
    localStorage.removeItem("verify_doc_remarks");
    navigate(`/verification-form/${id}`); // Absolute path
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setCurrentPage(1);
  };



  const getOrganisationListApi = async (perPage, currentPage, selectedStatus, searchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId) => {

    setLoading(true);
    try {
      const response = await getOrganisationList(perPage, currentPage, selectedStatus, searchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId);
      setOrganisationdataList(response?.data?.data);
    } catch (error) {
      console.error("Login error:", error);
    } finally {

      setLoading(false);
    }
  };



  const getAdminCategoryTypeListApi = async () => {
    try {
      const response = await getAdminCategoryType(2);
      // console.log("responseCategoryTYpe", response);
      setAdminCategoryTypeData(response?.data);
    } catch (error) {
      console.error("Login error:", error);
    }
  };
  useEffect(() => {
    setCurrentPage(1);
    setPerPage(10);
    setSelectedStatus(0);
    setDebouncedSearchValue("");
    setSelectedDistrictId("");
    setSelectedSubCategoryId("");
    setSelectedSportId("");
  }, []);


  useEffect(() => {
    getAdminCategoryTypeListApi();
  }, []);

  useEffect(() => {
    getOrganisationListApi(perPage, currentPage, selectedStatus, debouncedSearchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId);
  }, [currentPage, perPage, selectedStatus, debouncedSearchValue, selectedDistrictId, selectedSubCategoryId, selectedCategory, selectedSportId]);

  const handlePageChange = (event) => {
    // Adjusting for zero-based index by adding 1
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };
  const handleRefresh = useFilterReset({
    setSearchValue,
    setDebouncedSearchValue,
    setSelectedStatus,
    setSelectedDistrictId,
    setSelectedSubCategoryId,
    setCurrentPage,
    setSelectedCategory,
    setSelectedSubCategory,
    setPerPage,
    setCurrentPage,
    setSelectedSportId,
    fetchFunction: getOrganisationListApi,
    fetchArgs: [10, 1, 0, "", "", "", "", ""]

  });

  return (
    <>
      <PageTitle
        activeMenu="Institution List"
        motherMenu="Manage Registration"
      />
      <div className="col-12">
        <div className="card filter-card-wrapper">
          <div className="px-2">
            <div className="d-lg-flex justify-content-between">
              <div className="d-flex mt-3 mx-3">
                <div>
                  <FilterNumber value={perPage}
                    onChange={(val) => {
                      setPerPage(val);
                      setDownloadNumberPerPage(val);
                      setCurrentPage(1) // ✅ sync with download
                    }}
                  />
                </div>

                <div>
                  <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                </div>

              </div>
              <div className="d-flex mt-3 ">
                <div>
                  <Button
                    variant="primary"
                    className="mx-2"
                    onClick={() => setShowImportModal(true)}
                  >
                    Import Excel <i className="fa fa-plus"></i>
                  </Button>
                </div>
                <div>
                  <DownloadExcelButton
                    onClick={async () => {
                      const response = await getDwnLoadOrganisationList(
                        selectedStatus,
                        debouncedSearchValue,
                        selectedDistrictId,
                        selectedSubCategoryId,
                        selectedSportId
                      );
                      const allData = response?.data?.data?.data || [];
                      const withSerial = allData.map((item, index) => ({
                        serial: index + 1,  // matches header key
                        ...item
                      }));

                      return withSerial;
                    }}
                    headers={[
                      { label: "Sr.No", key: "serial" }, // ✅ add serial header
                      ...organisationExcelHeaders,
                    ]}
                    btnName="Download Excel"
                    fileName="InsitutionList.xlsx" />
                </div>


                <div>
                  <RefreshButton refreshCallback={handleRefresh} />
                </div>
              </div>

            </div>

            <div className="d-lg-flex mt-3 mx-3">
              <div className="mx-1 mb-2">
                <SportFilter setCurrentPage={setCurrentPage} />
              </div>
              <div className="mx-lg-2 mb-2">
                <Form.Select
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  className="me-2"
                  style={{ width: "100%", padding: "11px 50px 10px 11px" }}
                >
                  <option value="0">All Status</option>
                  <option value="reject">Reject</option>
                  <option value="pass">Pass</option>
                  <option value="final_submit">Final Submit</option>
                  <option value="initial">Initial</option>
                  <option value="ask_for_resubmit">Ask for Resubmit</option>
                </Form.Select>
              </div>
              {!(user?.role === 'admin' && user?.user_level === "3") && (
                <div className="me-2 mb-2">
                  <DistrictFilter setCurrentPage={setCurrentPage} />
                </div>
              )}


              <div>
                <CategorySubCategoryFilter typeId="2"
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  selectedSubCategory={selectedSubCategory}
                  setSelectedSubCategory={setSelectedSubCategory}
                  placeholderText="Institution"
                  setCurrentPage={setCurrentPage}
                />
              </div>



            </div>

          </div>


          <div className="card-body">
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="w-100 table-responsive">
                <div id="example_wrapper" className="dataTables_wrapper">
                  <form>
                    <table id="example" className="display w-100 dataTable">
                      <thead>
                        <tr>
                          <th>SN</th>
                          <th>Reg. No</th>
                          <th>Prov.Reg.Id</th>
                          <th>Name of Institution</th>
                          <th>Institution Email</th>
                          <th>Attempt</th>
                          <th>Contact Person Mobile</th>
                          <th>Registration Date</th>
                          {/* <th> Institution Password</th> */}
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {organisationdataList?.data?.length > 0 ? (
                          organisationdataList?.data?.map((data, index) => (
                            <tr key={index}>
                              <td>{index + 1 + (currentPage - 1) * perPage}</td>
                              <td>{data?.registration_number}</td>
                              <td>{data?.provisinal_registration_id}</td>
                              <td>{data?.name_of_organization}</td>
                              {/* <td>{data?.email}</td> */}
                              <td>
                               <TextMasked value={data?.email} type="email" />
                              </td>
                              <td>{data?.attempt_count + 1}</td>
                              {/* <td>{data?.contact_person_contact}</td> */}
                              <td><TextMasked value={data?.contact_person_contact} type="phone" /></td>
                              <td>{formatDateTime(data?.created_at)}</td>
                              {/* <td>{data?.org_pwd}</td> */}
                              <td
                                style={{ color: getStatusColor(data?.status) }}
                              >
                                {data?.status && formatStatus(data?.status)}
                              </td>
                              <td>
                                <div className="d-flex">
                                  <Button
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={() =>
                                      handleVerificationClick(data?.id)
                                    }
                                    disabled={
                                      data?.status === "initial" ||
                                      data?.status === "pass"
                                    }
                                  >
                                    Verify Application
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="13" className="text-center">
                              Data is not available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <ImportExcelModal
        showImportModal={showImportModal}
        setShowImportModal={setShowImportModal}
        adminCategoryTypeData={adminCategoryTypeData}
        getOrganisationListApi={getOrganisationListApi}
        currentPage={currentPage}
        perPage={perPage}
        selectedStatus={selectedStatus}
        setCurrentPage={setCurrentPage}
        selectedSportsId={selectedSportId}
      />

      <ReactPaginate
        nextLabel="next >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={8}
        marginPagesDisplayed={5}
        pageCount={Math.ceil(organisationdataList?.total / perPage)}
        previousLabel="< previous"
        pageClassName="page-item mx-1 my-1"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link mx-1 my-1"
        nextClassName="page-item mx-1 my-1"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item mx-1 my-1"
        breakLinkClassName="page-link"
        containerClassName="pagination d-flex flex-wrap"
        activeClassName="active"
        renderOnZeroPageCount={null}
        forcePage={currentPage - 1}
      />
    </>
  );
};

export default OrganizationList;
